module.exports = __webpack_public_path__ + "img/still (16).aee91513.jpg";